import {Action} from "../../../actions/actions";
import {PresetsActionTypes} from "../actions/actionTypes";
import _ from "lodash";

export function presetsList(state: any[] = [], action: Action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case PresetsActionTypes.TOGGLE_PRESET_ACTIVE_SUCCESS:
            const index = _.findIndex(newState.presets, [
                "id",
                action.payload.presetId
            ]);
            if (index > -1) {
                newState.presets[index].active = action.payload.active;
            }
            return newState;
        case PresetsActionTypes.GET_PRESETS_SUCCESS:
            return {
                presets: action.payload.results,
                count: action.payload.count,
                timestamp: new Date(
                    new Date().getTime() || 0
                ).toLocaleTimeString()
            };
        case PresetsActionTypes.TOGGLE_CERTIFIED_PRESET_SUCCESS:
            const indexCertified = _.findIndex(newState.presets, [
                "id",
                action.payload.presetId
            ]);
            if (indexCertified > -1) {
                newState.presets[indexCertified].certified = action.payload.certified;
            }
            return newState;
        default:
            return state;
    }
}

export function presetsLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case PresetsActionTypes.GET_PRESETS:
            return true;
        case PresetsActionTypes.GET_PRESETS_SUCCESS:
        case PresetsActionTypes.GET_PRESETS_FAIL:
            return false;
        default:
            return state;
    }
}

export function presetLoading(state: boolean = false, action: Action): boolean {
    switch (action.type) {
        case PresetsActionTypes.GET_PRESET:
            return true;
        case PresetsActionTypes.GET_PRESET_SUCCESS:
        case PresetsActionTypes.GET_PRESET_FAIL:
            return false;
        default:
            return state;
    }
}

export function editingPreset(state: any = {}, action: Action) {
    switch (action.type) {
        case PresetsActionTypes.CLEAR_PRESET:
            return {};
        case PresetsActionTypes.UPDATE_PRESET:
            return {
                ...state,
                ...action.payload.preset
            };
        default:
            return state;
    }
}

export function initialPreset(state: any = {}, action: Action) {
    switch (action.type) {
        case PresetsActionTypes.CLEAR_PRESET:
            return {};
        case PresetsActionTypes.GET_PRESET_SUCCESS:

            let preset = {
                ...action.payload,
                type: parseInt(action.payload.type)
            };
            const convertibleFields = [
                "contribution",
                "max_value",
                "increment_sound_value",
                "initial_value"
            ];
            preset.settings && Object.keys(preset.settings).map((key, index) => {
                if (convertibleFields.includes(key)) {
                    preset.settings[key] = preset.settings[key] / 100
                }
            })
            preset.settings.fractionated_jackpot_list && preset.settings.fractionated_jackpot_list.map((f, index) => {
                Object.keys(f).map((key, index) => {
                    f[key] = f[key] / 100
                })
            })

            Array.from(Array(5).keys()).map(i => {
                preset.settings['frequency_prizes_list' + i] && preset.settings['frequency_prizes_list' + i].map((f, index) => {
                    Object.keys(f).map((key, index) => {
                        f[key] = parseInt(f[key])
                        if (key == 'bet') {
                            f[0] = f[key]
                            delete f['bet']
                        }
                    })
                })
            })
            if (preset.type === 0) preset.stype = 0
            delete preset.prizes;
            delete preset.game_specific_settings;
            return preset;
        default:
            return state;
    }
}

export function initialPresetPrizes(state: any = {}, action: Action) {
    switch (action.type) {
        case PresetsActionTypes.CLEAR_PRESET:
            return {};
        case PresetsActionTypes.GET_PRESET_SUCCESS:
            // Format Preset JSON for Form
            const presetPrizes = action.payload.prizes;
            let formatedPrizeObject = {};
            const convertibleFields = [
                "contribution",
                "max_value",
                "increment_sound_value",
                "initial_value"
            ];
            presetPrizes.map(prize => {
                Object.keys(prize).map(prizeKey => {
                    formatedPrizeObject[`${prize.level}_${prizeKey}`] =
                        convertibleFields.includes(prizeKey)
                            ? prize[prizeKey] / 100
                            : prize[prizeKey];
                });

                prize.fractionated_jackpot_list && prize.fractionated_jackpot_list.map((f, index) => {
                    Object.keys(f).map((key, index) => {
                        f[key] = f[key] / 100
                    })
                })

            });
            return formatedPrizeObject;
        default:
            return state;
    }
}

export function initialGameSpecificSettings(state: any = [], action: Action) {
    switch (action.type) {
        case PresetsActionTypes.CLEAR_PRESET:
            return {};
        case PresetsActionTypes.GET_PRESET_SUCCESS:
            // Format Preset JSON for Form
            let presetGameSpecificSettings = action.payload.game_specific_settings;

                const convertibleFields = [
                    "contribution",
                    "max_value",
                    "increment_sound_value",
                    "initial_value"
                ];
            presetGameSpecificSettings.map(game_specific => {
                Object.keys(game_specific).map(key => {
                    if (convertibleFields.includes(key)) {
                        game_specific[key] = game_specific[key] / 100
                    }
                })
            })
            return presetGameSpecificSettings;
        default:
            return state;
    }
}

export function submitPresetLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case PresetsActionTypes.ADD_PRESET:
            return true;
        case PresetsActionTypes.ADD_PRESET_SUCCESS:
        case PresetsActionTypes.ADD_PRESET_FAIL:
            return false;
        default:
            return state;
    }
}

export function submittingPresetState(
    state: {
        error: boolean;
        success: boolean;
        message: string | null;
    } | null = null,
    action: Action
): {
    error: boolean;
    success: boolean;
    message: string | null;
} | null {
    switch (action.type) {
        case PresetsActionTypes.CLEAR_PRESET:
        case PresetsActionTypes.CLEAR_SUBMIT_PRESET:
            return null;
        case PresetsActionTypes.ADD_PRESET_SUCCESS:
            return {
                error: false,
                success: true,
                message: null
            };
        case PresetsActionTypes.ADD_PRESET_FAIL:
            return {
                error: true,
                success: false,
                message: action.payload.text ? action.payload.text : null
            };
        case PresetsActionTypes.EDIT_PRESET_SUCCESS:
            return {
                error: false,
                success: true,
                message: null
            };
        case PresetsActionTypes.EDIT_PRESET_FAIL:
            return {
                error: true,
                success: false,
                message: action.payload.text ? action.payload.text : null
            };
        default:
            return state;
    }
}
